import { Typography } from '@mui/material'
import { ReactElement } from 'react'
import { Kap_Goal } from 'src/@types/graphql'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { HtmlRenderer } from 'src/shared/presentation/HtmlRenderer'
import { ReadOnlyTextField } from 'src/shared/presentation/ReadOnly'
import { resolveGoalRatingColor } from 'src/shared/utils/StylingUtils'

interface Props {
  goal: Kap_Goal
}

export const KapMilestoneGoalFinalReportCardContent = ({ goal }: Props): ReactElement => {
  const { getMessage } = useMessageSource()
  const report = goal.kap_goal_final_reports[0]

  return (
    <>
      <ReadOnlyTextField text={getMessage('label.goal.rating.description.kap')}>
        {goal.description && <HtmlRenderer html={goal.description} />}
      </ReadOnlyTextField>
      <ReadOnlyTextField text={getMessage('label.goal.rating')}>
        {report?.rating && (
          <Typography color={resolveGoalRatingColor(report.rating)}>
            {getMessage(`label.goal.rating.${report.rating}`)}
          </Typography>
        )}
      </ReadOnlyTextField>
      <ReadOnlyTextField text={getMessage('label.goal.rating.reason.kap')} isLast>
        {report?.reason && <HtmlRenderer html={report.reason} />}
      </ReadOnlyTextField>
    </>
  )
}
